import Title from './Title.vue';

export { Title };
export default Title;
